import { Component, OnInit, Injectable } from '@angular/core';
import { FormGroup, FormControl,Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith, switchMap, debounceTime } from 'rxjs/operators';
import { ApiService } from '../services/api.service';
import { PurTransaction } from  '../Modules/tables';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition} from '@angular/material/snack-bar';
import { CreateCredComponent } from '../create-cred/create-cred.component';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { Router } from '@angular/router';

export const MY_FORMATS = {
  parse: {
    dateInput: 'L',
  },
  display: {
    dateInput: 'L',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'L',
    monthYearA11yLabel: 'MMM YYYY',
  },
};

@Injectable({
  providedIn: "root"
})

@Component({
  selector: 'app-purchase',
  templateUrl: './purchase.component.html',
  styleUrls: ['./purchase.component.css'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},],
})
export class PurchaseComponent implements OnInit {

  constructor(private service: ApiService,public dialog: MatDialog, private errorsnackBar: MatSnackBar, private successsnackBar: MatSnackBar, private router: Router) { }

  ngOnInit() { 
    this.filteredOptions = this.purchaseForm.controls['creditorName'].valueChanges.pipe(     // In filteredOptions array store observable of form control customerName
    startWith(""),                                                                          // Trigger event everytime form control's value changes
    debounceTime(300),                                                                  
    switchMap(value => this.doFilter(value))
  );
  }

  doFilter(value){                                                  //Get customers list
    return this.service.getCreditors().pipe(map(response =>response.filter(option => {
    return option.cred_name.indexOf(value) === 0;} )));
  }

  purchase_item: string[] = ['Coal', 'Matti', 'Pathai Bhaskat', 'Vehicle Parts','Vehicle Insurance','Bhatta Samaan', 'Miscellaneous']
  purchase_of: string[] = ['Office', 'NHIU', 'TIU']
  filteredOptions: Observable<string[]>;

  purchaseForm = new FormGroup({
    purchaseDate:   new FormControl(new Date(), Validators.required),
    creditorName:   new FormControl('', Validators.required),
    purchaseAmount: new FormControl('', Validators.required),
    purchaseItem:   new FormControl('', Validators.required),
    purchaseRemark: new FormControl('', Validators.required),
    purchaseOf:     new FormControl('', Validators.required),
  });
  
  createNewCreditor(): void {
    const dialogRef = this.dialog.open( CreateCredComponent , { width: '40vw', height: '80vh', disableClose: true, panelClass: "foo" } ); 
  }

  onReset(){
    this.purchaseForm.reset();
  }
  
  doPurTransaction(){
    this.service.addPurchase(this.purchaseForm.value).subscribe((transaction: PurTransaction)=>{
      this.openSuccessSnackBar('Success! Transaction is comeplete.', 'Close')
    },
    (error) => { this.openErrorSnackBar('Error occured. Transaction not complete.','Close');}
    );
  }

  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  openErrorSnackBar(message: string, action: string) {
    let er_snack = this.errorsnackBar.open(message, action, {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      panelClass: 'error_snackbar',
    });
    er_snack.onAction().subscribe(() => {
      setTimeout(()=>{this.reLoad();}, 2000)
    });
  }

  openSuccessSnackBar(message: string, action: string){
    let su_snack = this.successsnackBar.open(message, action, {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      panelClass: 'success_snackbar',
    });
    su_snack.onAction().subscribe(() => {
      setTimeout(()=>{this.reLoad();}, 2000)
    });
  }

  reLoad(){
    this.router.navigateByUrl( '/', {skipLocationChange: true } ).then(() => {
      this.router.navigateByUrl('/purexp')}); 
    console.log('It works!')
  }

}